import { render } from "./District.vue?vue&type=template&id=423249e8"
import script from "./District.vue?vue&type=script&lang=js"
export * from "./District.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__